import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Smartphone, Monitor } from 'lucide-react';

const AppCard = ({ app, compact = false }) => (
  <motion.div
    className={`${app.bgColor} p-6 rounded-lg h-full flex flex-col`}
    whileHover={{ y: -5 }}
    transition={{ duration: 0.2 }}
  >
    <div className="flex justify-center mb-4">
      <img
        src={app.icon}
        alt={`${app.name} App Icon`}
        className="w-20 h-20 rounded-2xl shadow-lg object-cover"
      />
    </div>
    <h3 className="text-xl font-serif font-bold mb-1 text-center">{app.name}</h3>
    <p className="text-sm text-gray-500 text-center mb-3">{app.tagline}</p>
    {!compact && (
      <p className="mb-4 text-center text-gray-600 text-sm flex-grow">{app.description}</p>
    )}
    <div className="flex flex-col items-center gap-2 mt-auto">
      {app.landingPageUrl ? (
        /* Dedicated landing pages are static sites outside the SPA — use a full page load */
        <a
          href={app.landingPageUrl}
          className="text-[#BAB37A] hover:text-[#9A9463] font-semibold flex items-center gap-1 text-sm"
        >
          <span>Learn More</span>
          <ArrowRight size={14} />
        </a>
      ) : (
        <Link
          to={`/apps/${app.slug}`}
          className="text-[#BAB37A] hover:text-[#9A9463] font-semibold flex items-center gap-1 text-sm"
        >
          <span>Learn More</span>
          <ArrowRight size={14} />
        </Link>
      )}
      <div className="flex items-center gap-2 text-xs text-gray-500">
        <Smartphone size={14} />
        <span>Android</span>
        {app.hasChromeExtension && (
          <>
            <span className="text-gray-300">|</span>
            <Monitor size={14} />
            <span>Chrome</span>
          </>
        )}
      </div>
    </div>
  </motion.div>
);

export default AppCard;
